import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { ConvenioAyudantiasDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class ConvenioAyudantiasService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getConvenioAyudantiasService(): Observable<BodyListResponse<ConvenioAyudantiasDTO>> {
    return this.http.get<BodyListResponse<ConvenioAyudantiasDTO>>(API_URL + '/api/v1/convenioAyudantias/todos');
  }

  guardarConvenioAyudantiasService(convenioAyudantiasDTO: ConvenioAyudantiasDTO): Observable<BodyResponse<ConvenioAyudantiasDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/convenioAyudantias', convenioAyudantiasDTO);
  }

  getConvenioAyudantiasPorCodigoService(codigo: string): Observable<BodyResponse<ConvenioAyudantiasDTO>> {
    return this.http.get<BodyResponse<ConvenioAyudantiasDTO>>(API_URL + '/api/v1/convenioAyudantias/' + codigo);
  }
}
